import RefundRoutes from "./RefundRoutes";
import RefundStore from "./RefundStore";
import RefundLinks from "./RefundLinks";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoute(...RefundRoutes);
    }
    if (options.store) {
      options.store.registerModule("Refund", RefundStore);
    }
    options.store.commit("Dashboard/SET_LINKS", RefundLinks);
  },
};
